import{INPUT_MANAGEMENT_METER_DAY_MODEL_LIST, INPUT_MANAGEMENT_METER_DAY_SEARCH, INPUT_MANAGEMENT_METER_DAY_PAGINATION,
    INPUT_MANAGEMENT_METER_DAY_DROP_DOWN_SEARCH_TYPE,INPUT_MANAGEMENT_METER_DAY_DROP_DOWN_SEARCH_SOURCE}from './actionType'

export const setModelDeviceListToState = (payload) => ({
    type: INPUT_MANAGEMENT_METER_DAY_MODEL_LIST,
    payload
})

export const setSearchToState = (payload) => ({
    type: INPUT_MANAGEMENT_METER_DAY_SEARCH,
    payload
})
export const setPaginationToState = (payload) => ({
    type: INPUT_MANAGEMENT_METER_DAY_PAGINATION,
    payload
})

export const setDropDownSearchType = (payload) => ({
    type: INPUT_MANAGEMENT_METER_DAY_DROP_DOWN_SEARCH_TYPE,
    payload
})

export const setDropDownSearchDataSource = (payload) => ({
    type: INPUT_MANAGEMENT_METER_DAY_DROP_DOWN_SEARCH_SOURCE,
    payload
})